import type { TextInput } from "react-native";

const focusInput = (inputRef: React.RefObject<TextInput | null>) => () => {
  inputRef.current?.focus();
};

export default focusInput;
